import React from 'react';

const LabelMapping = (props) => {
	const product = props.station.products;
	const shouldShowLabel = props.station.name.includes(',');

	let icon = '';
	if (product & 2 || product & 4) icon = 'sbb';
	if (product & 8) icon = 'bus';
	if (product & 16) icon = 'waves';
	if (product & 224) icon = 'mountains';

	return (shouldShowLabel ?
		<span className="subtitle">{props.labelText}</span> :
		<img src={require('../../assets/images/' + icon + '.svg')} alt={icon} />
	);
}

const TransportIcon = (props) => {
	const product = props.station.products;
	const icons = [];

	if (product & 1) icons.push('tram');
	if (product & 2) icons.push('rail-sd');
	if (product & 4) icons.push('rail-ld');
	if (product & 8) icons.push('bus');
	if (product & 16) icons.push('ship');
	if (product & 224) icons.push('cable');

	return (
		<span className="transport-icons">
			{
				icons.map(icon => <img key={icon} src={require('../../assets/images/' + icon + '.svg')} alt={icon} />)
			}
		</span>
	);
}

export { TransportIcon, LabelMapping };
